import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'shortNumber',
  standalone: false,
})
export class ShortNumberPipe implements PipeTransform {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  transform(value: number, args?: any): any {
    let abs = Math.abs(value);
    const rounder = Math.pow(10, 1);
    const isNegative = value < 0;
    let key = '';

    const powers = [
      {key: 'M', value: Math.pow(10, 6)},
      {key: 'K', value: 1000},
    ];

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < powers.length; i++) {
      let reduced = abs / powers[i].value;
      reduced = Math.round(reduced * rounder) / rounder;
      if (reduced >= 1) {
        abs = reduced;
        key = powers[i].key;
        break;
      }
    }
    return (isNegative ? '-' : '') + abs + key;
  }
}
